import { ROUTES } from "@/shared/constants/routes";
import SettingsIcon from "@/shared/icons/settings";
import TeamIcon from "@/shared/icons/team";
import { Building2, FileBadge, ShieldCheck, Sparkles } from "lucide-react";
import { NavItemData } from "../types/sidebar";

// Main navigation items (top section)
export const mainSidebarItems: NavItemData[] = [
  // {
  //   title: "AI Agent",
  //   Icon: RocketIcon,
  //   path: ROUTES.AGENT,
  // },
  // {
  //   title: "Sessions",
  //   Icon: SessionsIcon,
  //   path: ROUTES.AGENT_SESSIONS,
  // },
  {
    title: "Compliance",
    Icon: FileBadge,
    path: ROUTES.COMPLIANCE_GAP_ASSESSMENTS,
    canAccess: (permissions) => permissions.canAccessZaniaGapAssessment,
    children: [
      { title: "Gap Assessments", path: ROUTES.COMPLIANCE_GAP_ASSESSMENTS },
    ],
  },
  {
    title: "Third-Party Risk",
    Icon: Building2,
    path: ROUTES.THIRD_PARTY_HOME,
    canAccess: (permissions) => permissions.canAccessZaniaVendorAssessment,
    children: [
      { title: "Home", path: ROUTES.THIRD_PARTY_HOME },
      { title: "All Third-Parties", path: ROUTES.THIRD_PARTY_VENDORS_V2 },
      { title: "Breach History", path: ROUTES.THIRD_PARTY_BREACH_HISTORY },
      { title: "Issues", path: ROUTES.THIRD_PARTY_ISSUES },
      // { title: "Sessions", path: ROUTES.THIRD_PARTY_SESSIONS },
      {
        title: "Metrics",
        path: ROUTES.THIRD_PARTY_METRICS,
        canAccess: (orgName) => {
          const allowedOrgs = ["Ramki Test", "Zania", "Abdul Test"];
          return orgName ? allowedOrgs.includes(orgName) : false;
        },
      },
    ],
  },
  {
    title: "Internal Risk",
    Icon: ShieldCheck,
    path: ROUTES.INTERNAL_RISK_ASSESSMENTS,
    canAccess: (permissions) =>
      permissions.canAccessZaniaRiskAssessment ||
      permissions.canAccessZaniaFairAssessment,
    children: [
      { title: "Risk Assessments", path: ROUTES.INTERNAL_RISK_ASSESSMENTS },
    ],
  },
  {
    title: "Ask Zania",
    Icon: Sparkles,
    path: ROUTES.ASK_AI,
    canAccess: (permissions) => permissions.canAccessZaniaAskAi,
    featureName: "askZania",
  },
];

// Bottom navigation items (above user profile)
export const bottomSidebarItems: NavItemData[] = [
  //TODO: Add help section later
  // {
  //   title: "Help",
  //   Icon: HelpCircle,
  //   path: "#",
  //   isPlaceholder: true,
  // },
  {
    title: "Team",
    Icon: TeamIcon,
    path: ROUTES.TEAM,
  },
  {
    title: "Settings",
    Icon: SettingsIcon,
    path: ROUTES.SETTINGS,
  },
];

// Legacy export for backward compatibility
export const sidebarItems: NavItemData[] = [
  ...mainSidebarItems,
  ...bottomSidebarItems,
];
